import React from 'react';
import {createTheme, ThemeProvider as MuiThemeProvider} from '@mui/material/styles';

export function ThemeProvider({children}: React.PropsWithChildren<{}>) {
  const darkTheme = createTheme({
    palette: {
      mode: 'dark',
    },
  });

  return (
    <MuiThemeProvider theme={darkTheme}>
      {children}
    </MuiThemeProvider>
  );
}
